import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
/**
 * Get the next accordion state.
 *
 * @param {number} panelIndex Selected panel index
 * @param {(number|number[]|null)} state Expanded panel state
 *
 * @returns {(number|number[]|null)} Next panel state.
 */

export var getNextState = function getNextState(panelIndex, state) {
  if (Array.isArray(state)) {
    return state.indexOf(panelIndex) !== -1 ? state.filter(function (value) {
      return value !== panelIndex;
    }) : [].concat(_toConsumableArray(state), [panelIndex]).sort();
  }
  return panelIndex === state ? null : panelIndex;
};